import { createIcon } from '~/utils';

export const LinkedInIcon = createIcon({
  viewBox: '0 0 16 16',
  path: [
    <g clipPath='url(#clip0_908_1053)'>
      <path
        d='M3.58214 16H0.264286V5.31786H3.58214V16ZM1.92143 3.86071C0.860714 3.86071 0 2.98214 0 1.92143C0 0.860714 0.860714 0 1.92143 0C2.98214 0 3.84286 0.860714 3.84286 1.92143C3.84286 2.98214 2.98214 3.86071 1.92143 3.86071ZM15.9964 16H12.6857V10.8C12.6857 9.56071 12.6607 7.97143 10.9607 7.97143C9.23571 7.97143 8.97143 9.31786 8.97143 10.7107V16H5.65714V5.31786H8.83929V6.775H8.88571C9.32857 5.93571 10.4107 5.05 12.025 5.05C15.3821 5.05 16 7.26072 16 10.1321V16H15.9964Z'
        fill='#1275B1'
      />
    </g>,
    <defs fill='white'>
      <clipPath id='clip0_908_1053'>
        <rect width='16' height='16' />
      </clipPath>
    </defs>,
  ],
});
